import React, { useState } from 'react';
import { Tooltip } from '@mui/material';
import './ExpandableText.css';

const ExpandableText = ({ text, maxLines = 1 }) => {
    const [isExpanded, setIsExpanded] = useState(false);

    return (
        <Tooltip title={!isExpanded ? text : ""} arrow placement="top">
            <div
                className={`expandable-text ${isExpanded ? 'expanded' : 'collapsed'}`}
                onClick={() => setIsExpanded(!isExpanded)}>
                {text}
            </div>
        </Tooltip>
    );
};

export default ExpandableText;